import { useContext, useEffect, useState } from "react";
import { Context } from "..";
import AssociacionsAPI from "../API/AssociationsAPI";
import PaydayAPI from "../API/PaydayAPI";

const showLogs = false;
const usePayday = (count, responsibleId) => {

    const { store } = useContext(Context);
    const [ranges, setRanges] = useState([]);
    const [tasks, setTasks] = useState([]);
    const [hourCost, setHourCost] = useState(0);
    const [currDiscount, setCurrDiscount] = useState(0);

    const [paydaySumm, setSumm]  = useState(0);

    useEffect(() => {
        loadHourCost().then(() => showLogs && console.log("[✓] Стоимость часа по разделу заработной платы загружена"));
        loadTasks().then(() => showLogs && console.log("[✓] Список задач заработной платы загружен"));
        loadRanges().then(() => showLogs && console.log("[✓] Параметры банка загружены"));
    }, []);
    useEffect(() => {
        if (!ranges || ranges.length === 0) return;
        setSumm(mathSumm());
    }, [tasks, ranges, hourCost, count, currDiscount]);

    const loadHourCost = async () => {
        try {
            const association = await AssociacionsAPI.getAll();
            const result = await store.getPositionInfo(responsibleId ? responsibleId : association.data.payday_id);
            if (result.error === true) throw result;

            setCurrDiscount(result.response ? result.response.discount : 0);
            setHourCost(result.response ? result.response.hoursCost : 0);
        } catch (err) {
            showLogs && console.log("[x] Ошибка в расчетах стоимости часа раздела банка:", err);
            setHourCost(0);
        }
    }
    const loadTasks = async () => {
        try {
            const response = await PaydayAPI.getAll();
            if (response.status !== 200) throw response;
            if (!response.data || response.data.length === 0) return;

            setTasks(response.data);
        } catch (err) {
            showLogs && console.log("[x] Ошибка получения задач в модуле заработной платы:", err);
        }
    }
    const loadRanges = async () => {
        try {
            const response = await PaydayAPI.getAllRanges();
            if (response.status !== 200) throw response;
            if (!response.data || response.data.length === 0) return;

            for (let i = 0; i < response.data.length; i++) {
                response.data[i].hideStart = (response.data[i].start == response.data[i].end);
            }
            setRanges(response.data);
        } catch (err) {
            showLogs && console.log("[x] Ошибка получения промежутков в модуле заработной платы:", err);
        }
    }

    const hasInRange = () => {
        let rangeIndex = 0;
        while (rangeIndex < ranges.length) {
            let range = ranges[rangeIndex];
            if (count >= range.start && count <= range.end) return range;
            rangeIndex++;
        }
        return false;
    }
    const getSummsWithoutWorkers = () => {
        try {
            let summ = 0;
            for (let i = 0; i < tasks.length; i++) {
                let task = tasks[i];
                if (task.isRequired == true) summ += Math.ceil(task.time / (12 / task.interval)); 
            }
            return Math.ceil(summ * (hourCost / 60));
        } catch (err) {
            showLogs && console.log("[x] Ошибка вычисления значения в поле отсутсвтия сотрудников:", err);
            return 0;
        }
    }
    const getSummByCount = () => {
        let summForWorkers = 0;
        let summNotWorkers = 0;
        for (let i = 0; i < tasks.length; i++) {
            let task = tasks[i];
            if (task.isStatic == false) summForWorkers += Math.ceil(task.time / (12 / task.interval));
            else summNotWorkers += task.time;
        }
        return Math.ceil((summForWorkers * count + summNotWorkers) * (hourCost / 60));
    }

    const mathSumm = () => {
        try {
            let summ = 0;
            if (count == 0) summ = getSummsWithoutWorkers();
            else summ = getSummByCount(count) - (getSummByCount(count) / 100 * (hasInRange(count) ? hasInRange(count).percent : 0))

            return Math.ceil(summ);
        } catch (err) {
            showLogs && console.log("[x] Ошибка вычисления в разделе первички:", err);
            return 0;
        }
    }

    return {
        payday_summ: paydaySumm,
        payday_hourCost: hourCost,
        payday_changeDiscount: async (newDiscount) => {
            if (newDiscount == undefined) return;
            if (newDiscount == currDiscount) return;
            await loadHourCost();
            setCurrDiscount(newDiscount);
        },
        payday_changeAssociation: async () => {
            await loadHourCost();
        }
    }
}

export default usePayday;
